import paronApi from '@/utils/paron-api'

export default {
    getAllPlayers(page = 1, perPage = 60) {
        return paronApi.get(`player/all?page=${page}&per_page=${perPage}`)
    },

    getPlayerById(id) {
        return paronApi.get(`player/${id}`)
    },

    createPlayer(data) {
        return paronApi.uploadFile('player/new', data)
    },

    editPlayerById(id, data) {
        return paronApi.uploadFile(`player/${id}/edit`, data)
    },

    deletePlayerById(id) {
        return paronApi.delete(`player/${id}`)
    }

}
